import React, { Component } from 'react';

import essentialImg from '../../assets/images/newui/sellersignup/essential.svg'
import premiumImg from '../../assets/images/newui/sellersignup/premium.svg'
import ultimateImg from '../../assets/images/newui/sellersignup/ultimate.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import FeatureListItem from './FeatureListItem';
import './PlansSection.less'

class PlansSection extends Component {


    getImage = (type) => {
        switch (type) {
            case 'Essential':
                return essentialImg;
            case 'Premium':
                return premiumImg;
            case 'Ultimate':
                return ultimateImg;
            default:
                return premiumImg;
        }
    }

    getFeatureSectionHeight = () => {
        return (Math.max(...this.props.plans.map(p => p.features.length)) * 30) + 20;
    }

    isTwoPlans = (plans) => {
        return plans.length == 2 && window.innerWidth > 1032 ? true : false;
    }

    render() {
        const { plans } = this.props;
        const featureSectionHeight = this.getFeatureSectionHeight();
        return <div className='plan-section'>
            {plans.map(sp => <div className={`plan ${sp.plan.planType.toLowerCase()}-plan ${this.isTwoPlans(plans) ? "large" : ""}`}>
                {/* {sp.plan.planType == 'Premium' ? <div className='plan-top-heading'>Most Popular</div> : ''} */}
                {sp.plan.planType== 'Premium' ? <div className='plan-section-img'>
                    <img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/most-pop_1gmhgfwwkrkwyj0d_.png' />
                </div> : ''}
                <img src={this.getImage(sp.plan.planType)} />
                <div className="plan-heading">{sp.plan.planName}</div>
                <div className="plan-price">{(!sp.plan.trialDays || sp.plan.trialDays == 0) && <><span>${Number(sp.plan.price)}</span> <span>/month</span></>}</div>
                <div className="plan-sub-heading">
                    <b>{(!sp.plan.trialDays || sp.plan.trialDays == 0) && `+`} {`${sp.plan.commission ? sp.plan.commission + '% Commission' : '$' + Number(sp.plan.referralFee) + ' Referral'} Fee `}</b>
                    {this.props.selectedCategory.referralText}</div>
                <div className="plan-feature-section" style={{ height: featureSectionHeight }}>{sp.features.map(feature => <FeatureListItem content={feature.featureName} isHighlighted={feature.isHighlighted} />)}</div>
                <button className='plan-submit' onClick={() => this.props.onPlanSelect(sp)}>Select {sp.plan.planName}<img src={next} /></button>
            </div>)}
        </div>
    }
}

export default PlansSection;